import MainPage from "./views/main";
import FilterPage from "./views/history";

const RouteList = [
  /* Dashboard */
  {
    exact: true,
    path: "/",
    name: "Home",
    component: MainPage,
  },
  {
    exact: true,
    path: "/ket-qua-xo-so/:date",
    name: "ket-qua-xo-so",
    component: FilterPage,
  },
];

export default RouteList;
